import React from 'react'
import Asana from './asana.svg'
import GoogleSheets from './google-sheet.svg'
import GoogleForms from './google-forms.svg'
import GoogleCalendar from './google-calendar.svg'
import Facebook from './facebook.svg'
import Trello from './trello.svg'
import Gmail from './gmail.svg'
import ClickUp from './clickup.svg'
import YouTube from './youtube.svg'
import Slack from './slack.svg'
import Wordpress from './wordpress.svg'
import clsx from 'clsx'
import classes from './AppsGrid.module.scss'

interface GridItemProps {
  title: string
  imageSrc: string
  isBlueBackground?: boolean
  imageWidth: string
  imageHeight: string
}

interface GridWithTitleImageProps {
  items: GridItemProps[]
  isWide?: boolean
}

const GridWithTitleImage: React.FC<GridWithTitleImageProps> = ({
  items,
  isWide,
}) => {
  return (
    <div className={clsx(classes.list, isWide && classes.list__wide)}>
      {items.map((item, index) => (
        <figure className={classes.item} key={index}>
          <div
            className={clsx(
              classes.image,
              item.isBlueBackground && classes.bg__blue,
            )}
          >
            <img
              width={item.imageWidth}
              height={item.imageHeight}
              loading='lazy'
              src={item.imageSrc}
              alt={item.title}
            />
          </div>
          <figcaption className={classes.caption}>{item.title}</figcaption>
        </figure>
      ))}
    </div>
  )
}

interface AppsGridProps {
  isWide?: boolean
}

export default function AppsGrid({ isWide }: AppsGridProps) {
  const apps = [
    {
      title: 'Google Sheets',
      imageSrc: GoogleSheets.src,
      imageWidth: '35',
      imageHeight: '48',
    },
    {
      title: 'Gmail',
      imageSrc: Gmail.src,
      imageWidth: '48',
      imageHeight: '36',
    },
    {
      title: 'Facebook',
      imageSrc: Facebook.src,
      isBlueBackground: true,
      imageWidth: '64',
      imageHeight: '64',
    },
    {
      title: 'Trello',
      imageSrc: Trello.src,
      isBlueBackground: true,
      imageWidth: '64',
      imageHeight: '64',
    },
    {
      title: 'Google Forms',
      imageSrc: GoogleForms.src,
      imageWidth: '35',
      imageHeight: '48',
    },
    {
      title: 'Google Calendar',
      imageSrc: GoogleCalendar.src,
      imageWidth: '44',
      imageHeight: '44',
    },
    {
      title: 'Facebook Pages',
      imageSrc: Facebook.src,
      isBlueBackground: true,
      imageWidth: '64',
      imageHeight: '64',
    },
    {
      title: 'Asana',
      imageSrc: Asana.src,
      imageWidth: '43',
      imageHeight: '40',
    },
    {
      title: 'ClickUp',
      imageSrc: ClickUp.src,
      imageWidth: '38',
      imageHeight: '45',
    },
    {
      title: 'YouTube',
      imageSrc: YouTube.src,
      imageWidth: '46',
      imageHeight: '33',
    },
    {
      title: 'Slack',
      imageSrc: Slack.src,
      imageWidth: '42',
      imageHeight: '42',
    },
    {
      title: 'WordPress',
      imageSrc: Wordpress.src,
      imageWidth: '62',
      imageHeight: '62',
    },
  ]

  return <GridWithTitleImage items={apps} isWide={isWide} />
}
